import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api.interface';
import { CarSetting, CreateCarSettingDto } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class CarSettingsService {
  private apiUrl = '/api/company/cars';

  constructor(private http: HttpClient) {}

  getSettings(parentId: number): Observable<ApiResponse<CarSetting[]>> {
    return this.http.get<ApiResponse<CarSetting[]>>(
      `${this.apiUrl}/${parentId}/settings`
    );
  }

  getSettingByKey(
    parentId: number,
    key: string
  ): Observable<ApiResponse<CarSetting>> {
    return this.http.get<ApiResponse<CarSetting>>(
      `${this.apiUrl}/${parentId}/settings/${key}`
    );
  }

  upsertSetting(
    parentId: number,
    dto: CreateCarSettingDto
  ): Observable<ApiResponse<CarSetting>> {
    return this.http.post<ApiResponse<CarSetting>>(
      `${this.apiUrl}/${parentId}/settings`,
      dto
    );
  }

  bulkUpsertSettings(
    parentId: number,
    settings: CreateCarSettingDto[]
  ): Observable<ApiResponse<CarSetting[]>> {
    return this.http.put<ApiResponse<CarSetting[]>>(
      `${this.apiUrl}/${parentId}/settings/bulk`,
      settings
    );
  }

  deleteSetting(
    parentId: number,
    key: string
  ): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(
      `${this.apiUrl}/${parentId}/settings/${key}`
    );
  }
}
